<template>
    <article :class="classes" v-bind="attributes">
        <template v-if="isMobile()">

            <h2 class="title title--dash slide__title" :aria-label="header.map(el => el).join(' ')">
                <template v-for="(line, l) in header">
                    <span :key="`title-last-${l}`" data-v-line v-html="line" />
                </template>
            </h2>

            <p 
                class="p-summary" 
                v-html="body" 
            />

            <DiscoverButtons v-bind="{
                tag: 'div',
                headingTag: 'h3',
                classes: 'outro slide__details'
            }" />

            <span>
                <div class="slide__waves">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 550"><path fill="rgb(79, 45, 127)" d="M1564.711,566.812 L1564.711,61.292 C1519.848,63.888 1488.438,27.732 1455.068,12.618 C1426.147,-0.473 1394.892,-0.705 1360.736,1.349 C1263.771,7.169 1257.960,97.274 1180.291,114.031 C1142.506,122.202 1097.710,77.686 1070.501,65.361 C1041.561,52.273 1010.307,52.041 976.151,54.094 C879.167,59.917 873.336,150.024 795.628,166.787 C757.825,174.960 712.990,130.450 685.744,118.131 C656.783,105.044 625.530,104.813 591.355,106.869 C494.389,112.689 488.540,202.799 410.851,219.559 C373.009,227.738 328.198,183.253 300.908,170.910 C271.948,157.824 240.694,157.592 206.519,159.649 C152.889,162.870 127.104,191.854 101.629,219.964 C71.319,246.415 8.593,232.065 0.812,192.036 L0.812,566.812 L1564.711,566.812 Z"/></svg>
                </div>

                <slot name="nav" />

                <div class="slide__circles" v-if="circles">
                    <slot name="circles" />
                </div>

                <!-- <div class="slide__bullets">
                    <slot name="bullets" />
                </div> -->
            </span>
        </template>

        <template v-else>
            <div data-flex="row" class="h-entry" itemscope>
                
                <section class="slide__copy">
                    <animate-in :ready="waves" :delay="1000">
                        <h1 
                            class="title title--dash slide__title"
                            :aria-label="header.map(el => el).join(' ')"
                            :data-maxs="maxSlides" 
                            itemprop="title"
                        >
                            <template v-for="(line, l) in header">
                                <span :key="`title-dash-${l}`" data-v-line v-html="line" />
                            </template>
                        </h1>
                        <p 
                            class="slide__text p-summary" 
                            v-html="body" 
                        />
                    </animate-in>
                </section>
                
                <section class="slide__circle e-content">
                    <animate-in :ready="waves" :delay="1600">
                        <DiscoverButtons data-flex="row" v-bind="{
                            tag: 'nav',
                            classes: 'outro',
                            name: 'your-story-title'
                        }" />
                    </animate-in>
                </section>
            </div>

            <div class="slide__circles" v-if="circles">
                <slot name="circles" v-bind="{ circles }" />
            </div>
            
            <div class="slide__wave" data-flex>
                <transition name="slide">
                    <div class="slide__waves" v-show="waves">
                        <svg v-if="$route.path.includes('discover-')" fill="none" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 550"><path d="M1564.711,566.812 L1564.711,61.292 C1519.848,63.888 1488.438,27.732 1455.068,12.618 C1426.147,-0.473 1394.892,-0.705 1360.736,1.349 C1263.771,7.169 1257.960,97.274 1180.291,114.031 C1142.506,122.202 1097.710,77.686 1070.501,65.361 C1041.561,52.273 1010.307,52.041 976.151,54.094 C879.167,59.917 873.336,150.024 795.628,166.787 C757.825,174.960 712.990,130.450 685.744,118.131 C656.783,105.044 625.530,104.813 591.355,106.869 C494.389,112.689 488.540,202.799 410.851,219.559 C373.009,227.738 328.198,183.253 300.908,170.910 C271.948,157.824 240.694,157.592 206.519,159.649 C152.889,162.870 127.104,191.854 101.629,219.964 C71.319,246.415 8.593,232.065 0.812,192.036 L0.812,566.812 L1564.711,566.812 Z"/></svg>
                        <Copyright name="privacy" />
                    </div>
                </transition>
            </div>

            <slot name="nav" />

            <SplashImage
                v-if="$store.getters['isUserStudent']"
            />

            <!-- <div class="slide__bullets">
                <slot name="bullets" />
            </div> -->
        </template>
    </article>
</template>

<script>
import { wavify } from '@/mixins/slidify'

import AnimateIn from '../Ui/Animate'
import DiscoverButtons from '../Discover/DiscoverButtons'

const waveAnimate = {
    data: () => ({
        circles: false,
        waves: false,
    }),
    computed: {
        mobile() {
            return this.isMobile()
        },
    },
    methods: {
        show() {
            setTimeout(() => {
                this.waves = this.circles = true
                this.$parent.$emit('slide-waves-toggle', 1)
            }, 1600)
        },
        hide() {
            this.waves = false
            setTimeout(() => {
                this.circles = false
                this.$parent.$emit('slide-waves-toggle', 0)
            }, 0)
        },
        mobileWatcher( value ) {
            if ( value ) {
                this.show()
            }
            else if ( !this.active ) {
                this.hide()
            }
        },
        waveWatcher( value ) {
            if ( this.isMobile() ) return;
            value ? this.show() : this.hide()
        },
    },
}

export default {
    props: {
        classes: String,
        header: {
            type: [Array, String],
            required: true
        },
        body: {
            type: [Array, String],
            required: true
        },
        attributes: [Object, Boolean],
        active: [String, Boolean],
        hasCircles: {
            type: Boolean,
            default: true
        },
        hasWave: {
            type: Boolean,
            default: true
        },
        maxSlides: {
            type: Number,
            required: true
        },
    },

    mixins: [
        wavify,
        waveAnimate,
    ],

    components: {
        AnimateIn,
        DiscoverButtons,
    },

    watch: {
        mobile: {
            immediate: true,
            handler( value ) {
                this.mobileWatcher(value)
            }
        },
        active( value ) {
            this.waveWatcher(value)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/logic/vars.scss';
@import '../../assets/styles/logic/functions.scss';
@import '../../assets/styles/logic/mixins.scss';

$ratio: percentage( 550 / 1500 );
$className: last;

[class].scaled-fast {
    transform: scale3d(0, 0, 1);
    transition: none;
}

.slide--#{$className} {
    flex-wrap: wrap;
    
    ::v-deep text { display: none }
}

::v-deep .outro {
    position: static;

    .subtitle {
        @include media( 768px, 1366px ) {
            margin-bottom: 0;
            font-size: _f( 14 );
            padding: {
                left: 16%;
                right: 16%
            }
        }
    }
    @include media( 768px, 1366px) {
        .button {
            --btn-height: 48px;
            --btn-font-size: 13px;
        }
    }
}

@include media( mobile ) {
    .slide--#{$className} {
        ::v-deep .slide__waves svg {
            position: absolute;
            bottom: 0; left: -1vw;
            margin-top: -150vw;
            min-width: 550vw
        }
        ::v-deep .slide__details {
            min-width: 70%;
            text-align: center;
            margin: 30px auto 0 auto;
            display: block;
            
            > :nth-child(n) {
                display: flex;
                justify-content: center;
            }

            > a br { display: none }
        }
    }
}
@media (min-width: 768px) {
    .slide--#{$className} {
        height: 100vh;
        ::v-deep .slide__waves {
            &::after {
                content: '';
                position: absolute;
                left: 0; bottom: 0;
                width: 100%;
                height: auto;
            }
            svg {
                min-width: calc(100vw + 2px);
                margin-left: -1px;
            }
        }
        ::v-deep .slide__circle {
            align-self: flex-start;
            min-height: 0;

            .subtitle {
                text-align: center;
            }
        }
        ::v-deep .slide__circles {
            // margin-top: auto;
            // margin-bottom: auto;
            // position: relative;
            z-index: 1;
            top: 75vh;
            width: 100vw;
            // padding-bottom: $ratio;
            pointer-events: none;

            // @media (min-width: 768px) and (max-width: 1366px) {
            //     position: absolute;
            // }

            a { pointer-events: all }
        }
    }
}
</style>